<template>
    <layout-box-sidebar>
        <template #title>
            <slot name="title">
                {{ lang('common::common.panels.actions') }}
            </slot>
        </template>
        <div class="flex flex-col px-4 py-2 space-y-4">
            <slot></slot>
        </div>
    </layout-box-sidebar>
</template>

<script setup lang="ts"></script>
